import { render } from "./Overrides.vue?vue&type=template&id=a984e868"
import script from "./Overrides.vue?vue&type=script&lang=js"
export * from "./Overrides.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__